import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import * as format from "date-fns/format";
import * as startOfMonth from "date-fns/start_of_month";
import * as endOfMonth from "date-fns/end_of_month";
import * as getDay from "date-fns/get_day";
import * as subDays from "date-fns/sub_days";
import * as getDaysInMonth from "date-fns/get_days_in_month";
import * as addMonths from "date-fns/add_months";
import * as subMonths from "date-fns/sub_months";
import * as isToday from "date-fns/is_today";
import * as getMonth from 'date-fns/get_month'
import * as getYear from 'date-fns/get_year'
import * as parse from 'date-fns/parse'
import * as setDate from 'date-fns/set_date';
import {CalendarTodayService} from "../../Services/calendar-today/calendar-today.service";
import {LocalDate, LocalTime, nativeJs} from "js-joda";
import {AppointmentsService} from "../../Services/appointments/appointments.service";
import {Observable} from "rxjs/Observable";
import {scrollToElement} from '../../helpers';

// Production steps of ECMA-262, Edition 5, 15.4.4.17
// Reference: http://es5.github.io/#x15.4.4.17
if (!Array.prototype.some) {
  Array.prototype.some = function (fun/*, thisArg*/) {
    'use strict';
    if (this == null) {
      throw new TypeError('Array.prototype.some called on null or undefined');
    }
    if (typeof fun !== 'function') {
      throw new TypeError();
    }
    var t = Object(this);
    var len = t.length >>> 0;
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++) {
      if (i in t && fun.call(thisArg, t[i], i, t)) {
        return true;
      }
    }
    return false;
  };
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  safeGetDaysAvailable(date: Date) {
    if(this.daysAvailable.hasOwnProperty(LocalDate.from(nativeJs(date)).withDayOfMonth(1).toString())) {
      return this.daysAvailable[LocalDate.from(nativeJs(date)).withDayOfMonth(1).toString()];
    } else {
      return [];
    }
  }

  loadDates(currentDate: Date) {
    let current: LocalDate = LocalDate.from(nativeJs(currentDate)).withDayOfMonth(1);
    let obs: Observable<{date:LocalDate, dates:LocalDate[]}>[] = [];
    for (let i of [-1, 0, 1]) {
      let date = current.plusMonths(i);
      if (!this.daysAvailable.hasOwnProperty((date.toString()))) {
        obs.push(this.appointmentsService.getDates(date).map((dates) => {
          return {date: date, dates: dates}
        }));
      }
    }
    Observable.merge(...obs)
      .subscribe((obj) => {
        this.daysAvailable[obj.date.toString()] = obj.dates;
      })
  }

  daysAvailable = {};

  backOneMonth() {
    this.todayService.currentDate = subMonths(this.todayService.currentDate, 1);
    this.loadDates(this.todayService.currentDate);
    var td = document.getElementsByClassName('today');
    if ( td[0] !== undefined && td[0] !== null ) {
      td[0].classList.remove('active');
    }
  }

  forwardOneMonth() {
    this.todayService.currentDate = addMonths(this.todayService.currentDate, 1);
    this.loadDates(this.todayService.currentDate);
    var td = document.getElementsByClassName('today');
    if ( td[0] !== undefined && td[0] !== null ) {
      td[0].classList.remove('active');
    }
  }

  ngOnInit(): void {
    this.loadDates(this.todayService.currentDate);
  }

  appointmentsService;

  constructor(todayService: CalendarTodayService, appointmentsService: AppointmentsService) {
    this.todayService = todayService;
    this.appointmentsService = appointmentsService;
  }

  someEquals(arr: LocalDate[], arg: Date) {
    if(typeof arg == "undefined") {
      return false;
    }
    return arr.some((x) => x.equals(LocalDate.from(nativeJs(arg))));
  }

  getMonth = getMonth;
  getYear = getYear;
  format = format;
  startOfMonth = startOfMonth;
  getDay = getDay;
  subDays = subDays;
  getDaysInMonth = getDaysInMonth;
  isToday = isToday;
  parse = parse;
  todayService: CalendarTodayService;

  translateToDate(i, j): Date {
    if (i * 7 + j - this.weekDayOfFirstOfMonth + 1 < this.getDaysInMonth(this.todayService.currentDate) && i * 7 + j >= this.weekDayOfFirstOfMonth) { //This Month
      return setDate(this.todayService.currentDate, i * 7 + j - this.weekDayOfFirstOfMonth + 1);
    } else if (i * 7 + j - this.weekDayOfFirstOfMonth + 1 >= this.getDaysInMonth(this.todayService.currentDate)) { //Next Month
      return setDate(addMonths(this.todayService.currentDate, 1), i * 7 + j - this.weekDayOfFirstOfMonth + 1 - getDaysInMonth(this.todayService.currentDate));
    } else if (i * 7 + j < this.weekDayOfFirstOfMonth) {
      return subDays(startOfMonth(this.todayService.currentDate), this.weekDayOfFirstOfMonth - (i * 7 + j));//Last month
    } else {
      console.warn("DAY DETECTION BROKEN");
      debugger;
    }
  }

  headerComponent = CalendarHeaderComponent;
  title = "Pick a Day"; // there is a check of title in the header component

  get weekDayOfFirstOfMonth(): number {
    return getDay(startOfMonth(this.todayService.currentDate));
  }

  get weekDayOfLastOfMonth(): number {
    return getDay(endOfMonth(this.todayService.currentDate));
  }

  @Output() dateSelected = new EventEmitter();

  openDate(date: Date, emptyBlocker) {
    var td = document.getElementsByClassName('today');
    if ( td[0] !== undefined && td[0] !== null ) {
      td[0].classList.remove('active');
    }
    if (emptyBlocker) {
      return;
    }
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);
    this.dateSelected.emit(date);
  }
}

@Component({
  selector: 'app-calendar-header',
  template: '<div class="appbutton" (click)="setToToday()">Today</div>',
  styles: [`.appbutton {
    font-size: 0.7em;
    user-select: none;
    cursor: pointer;
  }`]
})
export class CalendarHeaderComponent {
  calendar: CalendarComponent;

  constructor(private todayService: CalendarTodayService) {
  }

  setToToday() {
    this.todayService.currentDate = startOfMonth(new Date());
    setTimeout(function(){
      var td = document.getElementsByClassName('today');
      if ( td[0] !== undefined && td[0] !== null ) {
        td[0].classList.add('active');
      }
    }, 300);
  }
}



// WEBPACK FOOTER //
// /app/src/app/Components/calendar/calendar.component.ts